import { Check, Circle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { passwordRequirementChecks } from '../../lib/passwordValidation';

export default function PasswordRequirements({ value, id }: { value: string; id: string }) {
  const { t } = useTranslation('accountAccess');
  return <ul id={id} className="password-requirements" aria-live="polite">
    {passwordRequirementChecks(value).map((met, index) => <li key={index} data-met={met}>{met ? <Check size={14} aria-hidden="true" /> : <Circle size={14} aria-hidden="true" />}<span>{t(`requirements.${index}`)}</span>{met && <span className="sr-only">✓</span>}</li>)}
  </ul>;
}
